import { z } from 'zod/v4';

import { normalizeSocialWidgetArgs } from './social-widget-args.normalization';
import { partialSocialWidgetDataSchema } from './partial-social-widget-data.schema';

/**
 * `data` is the same shared partial `create_social_widget` uses (minus create's required-`socials`
 * tightening), kept deliberately identical so a model that has just seen its own create call in the
 * conversation history can pattern-match straight onto this tool — the same reasoning behind
 * `update_button_widget` reusing `partialButtonItemSchema`.
 */
const updateSocialWidgetObjectSchema = z.object({
    widgetId: z.string().describe('Id of the social-networks widget to update.'),
    data: partialSocialWidgetDataSchema.describe(
        'Partial patch — only the fields you provide are changed. Note socials REPLACES the whole entry ' +
            'list, so include every entry you want to keep.'
    ),
});

export const updateSocialWidgetArgsSchema = z.preprocess(normalizeSocialWidgetArgs, updateSocialWidgetObjectSchema);
